<script lang="ts">
	//UI
	//Utils
	//Types
	//Props
	export let fill = "#6591fa";
	export let stroke = "#fff";
	export let loading = false;
	//Constants
	//Variables
	//Functions
	//Do

</script>

<svg
	class:loading
	xmlns="http://www.w3.org/2000/svg"
	width="100%"
	height="100%"
	viewBox="0 0 27.021 27.016">
	<g>
		<g>
			<path
				d="M-396.531 356.989c0-.486-.013-.829 0-1.171a1.328 1.328 0 0 1 1.323-1.382 1.289 1.289 0 0 1 1.3 1.385q.025 2.283.012 4.566a1.268 1.268 0 0 1-1.345 1.338q-2.289.03-4.578.017a1.306 1.306 0 0 1-1.388-1.3 1.323 1.323 0 0 1 1.41-1.282c.5-.01 1.008 0 1.71 0-.291-.249-.436-.4-.6-.515-3.608-2.493-7.428-2.847-11.262-.726a9.827 9.827 0 0 0-5.323 9.856 10.372 10.372 0 0 0 9.616 9.573 10.427 10.427 0 0 0 11-8.584 14.9 14.9 0 0 0 .115-2.787c-.013-.883.4-1.5 1.167-1.563a1.326 1.326 0 0 1 1.441 1.377 12.986 12.986 0 0 1-11.21 14.057 13.046 13.046 0 0 1-14.566-10.631 12.953 12.953 0 0 1 11.15-15.117 12.7 12.7 0 0 1 9.24 2.316c.228.16.45.327.788.573z"
				transform="translate(418.414 -353.478)"
				fill={fill}
				stroke={stroke} />
		</g>
	</g>
</svg>

<style lang="scss">
	svg {
		&.loading {
			animation-name: loading;
			animation-duration: 2s;
			animation-direction: alternate;
			animation-iteration-count: infinite;
		}
	}

	@keyframes loading {
		from {
			transform: rotate(0deg);
		}

		to {
			transform: rotate(360deg);
		}
	}

</style>
